"use client";

import { useState } from "react";
import { AvatarPortrait } from "./avatar-portrait";
import { cn } from "./ui";
import { pickSampleVideo } from "@/lib/sample-media";

/**
 * Avatar 卡片的视频人物展示：静音循环播放数字人样片。
 * previewVideoUrl 留给真实素材（HeyGen 每个 avatar 自带 preview 视频，
 * 引擎接通后从目录透传进来）；未提供时用占位样片池按 id 稳定取一条，
 * 视频加载失败则回落到原来的插画头像。
 */

export function AvatarVideo({
  avatarId,
  previewVideoUrl,
  className,
}: {
  avatarId: string;
  previewVideoUrl?: string;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const src = previewVideoUrl ?? pickSampleVideo(avatarId);

  if (failed) {
    return <AvatarPortrait avatarId={avatarId} className={className} />;
  }
  return (
    <div className={cn("relative overflow-hidden", className)}>
      <video
        src={src}
        className="absolute inset-0 h-full w-full bg-black/40 object-cover"
        muted
        loop
        autoPlay
        playsInline
        preload="metadata"
        onError={() => setFailed(true)}
      />
      <span className="absolute top-2 right-2 rounded-full bg-black/55 px-2 py-0.5 text-[10px] text-white/80 backdrop-blur-sm">
        Sample
      </span>
    </div>
  );
}
